import { ROUTE_PATHS } from 'routes/route-paths';

const isSalesforceV2Host =
  process.env.IS_MODULE_FEDERATION === 'true' ||
  (typeof window !== 'undefined' &&
    window.location.pathname.includes('/settings/integrations/salesforce-v2'));

const SALESFORCE_SETTINGS_BASE = isSalesforceV2Host
  ? 'settings/integrations/salesforce-v2'
  : ROUTE_PATHS.SALESFORCE_SETTINGS;

const SALESFORCE_SETTINGS_INTEGRATION_TEMPLATE = isSalesforceV2Host
  ? 'settings/integrations/salesforce-v2/:integrationId'
  : ROUTE_PATHS.SALESFORCE_SETTINGS_INTEGRATION;

/**
 * Generate URL for creating a new Salesforce automation
 * @param integrationId - The integration ID
 * @returns The URL for creating a new automation
 */
export const getSalesforceNewAutomationUrl = (
  integrationId: string,
): string => {
  return `/${SALESFORCE_SETTINGS_BASE}/${integrationId}/automations/new`;
};

/**
 * Generate URL for editing a Salesforce automation
 * @param integrationId - The integration ID
 * @param automationId - The automation ID
 * @returns The URL for editing an automation
 */
export const getSalesforceEditAutomationUrl = (
  integrationId: string,
  automationId: number,
): string => {
  return `/${SALESFORCE_SETTINGS_BASE}/${integrationId}/automations/${automationId}/edit`;
};

/**
 * Generate URL for editing a Salesforce automation (alternative naming)
 * @param integrationId - The integration ID
 * @param automationId - The automation ID
 * @returns The URL for editing an automation
 */
export const getSalesforceAutomationEditUrl = (
  integrationId: string,
  automationId: number,
): string => {
  return getSalesforceEditAutomationUrl(integrationId, automationId);
};

export const getSalesforceBaseUrl = (integrationId: string): string => {
  return `/${SALESFORCE_SETTINGS_INTEGRATION_TEMPLATE.replace(
    ':integrationId',
    integrationId,
  )}`;
};

export const getSalesforceAutomationUrl = (integrationId: string): string => {
  return `/${SALESFORCE_SETTINGS_BASE}/${integrationId}/automations`;
};
